<div class="flex flex-col items-center py-8 gap-2.5">
  <mat-icon class="icon-size-12" svgIcon="blank_paper"></mat-icon>
  <div class="font-semibold">{{ message }}</div>
</div>
